module.exports = __webpack_public_path__ + "img/cal.8269935f.webp";